import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class LoadingService {
    isLoading = false;

    constructor(private translate: TranslateService,
                public loadingController: LoadingController) {
    }

    async present() {
        this.isLoading = true;
        return await this.loadingController.create({
            message: 'Loading...'
        }).then(a => {
            a.present().then(() => {
                // console.log('presented');
                if (!this.isLoading) {
                    a.dismiss();
                }
            });
        });
    }

    async indicator(message: number) {
        this.isLoading = true;
        return await this.loadingController.create({
            message: message.toString()
        }).then(a => {
            a.present().then(() => {
                // console.log('presented');
                if (!this.isLoading) {
                    a.dismiss();
                }
            });
        });
    }

    async dismiss() {
        if (this.isLoading === true) {
            this.isLoading = false;
            return await this.loadingController.dismiss();
        }
    }
}
